import React, { useState } from 'react';
import { MerchManageOrderTable } from '../..';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { LabeledInput, SelectInput } from '../../../Components';
import './index.css';

//This is actually admin panel order but since name chages a lot afterward to we didnt renamed it

const MerchantPanel = () => {
    const [rowPerPage, setRowPerPage] = useState(10);
    const [filters, setFilters] = useState({ orderId: '', name: '', paymentType: '', status: '' });
    const changeFilterHandler = (field, newValue) => {
        setFilters((prev) => {
            const old = { ...prev };
            old[field] = newValue;
            return old;
        });
    };
    return (
        <div className="manage_orders_merch">
            <div className="manage_orders_merch_head">
                <h2>MANAGE ORDERS</h2>
                <div className="manage_orders_merch_head_right">
                    <button className="btn-gray">Export to CSV</button>
                </div>
            </div>
            <div className="manage_orders_merch_mid">
                <div style={{ display: 'flex' }}>
                    <LabeledInput
                        name="Order ID"
                        value={filters.orderId}
                        changeHandler={(e) => {
                            changeFilterHandler('orderId', e.target.value);
                        }}
                        label={'Order ID'}
                    />
                    <LabeledInput
                        name="name"
                        value={filters.name}
                        changeHandler={(e) => {
                            changeFilterHandler('name', e.target.value);
                        }}
                        label={'Merchant Name'}
                    />
                    <div>
                        <SelectInput
                            label="Payment Type"
                            outlined={true}
                            value={filters.paymentType}
                            changeHandler={(e) => {
                                changeFilterHandler('paymentType', e.target.value);
                            }}
                            options={[
                                { name: 'None', value: '' },
                                { name: 'Online', value: 'Online' },
                                { name: 'COD', value: 'COD' },
                            ]}
                        />
                    </div>
                    <div>
                        <SelectInput
                            label="Status Type"
                            outlined={true}
                            value={filters.status}
                            changeHandler={(e) => {
                                changeFilterHandler('status', e.target.value);
                            }}
                            options={[
                                { name: 'None', value: '' },
                                { name: 'Processing', value: 'Processing' },
                                { name: 'Ready To Dispatch', value: 'Ready To Dispatch' },
                                { name: 'Dispatched', value: 'Dispatched' },
                                { name: 'On Hold', value: 'On Hold' },
                                { name: 'Cancelled', value: 'Cancelled' },
                                { name: 'Return', value: 'Return' },
                            ]}
                        />
                    </div>
                </div>

                <div style={{ marginTop: '1rem', display: 'flex' }} className="manage_orders_merch_mid_right">
                    <button style={{ marginRight: '2rem' }} className="btn-gray">
                        Reset
                    </button>
                    <button className="btn-orange">
                        <p>Search</p>
                    </button>
                </div>
            </div>
            <div className="manage_orders_merch_body">
                <MerchManageOrderTable />
            </div>{' '}
            <div className="pagination_footer">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SelectInput
                        marginZero
                        style={{ minWidth: '30px' }}
                        label="Rows per page:"
                        value={rowPerPage}
                        changeHandler={(e) => {
                            setRowPerPage(e.target.value);
                        }}
                        options={[
                            { name: '10', value: 10 },
                            { name: '25', value: 25 },
                            { name: '50', value: 50 },
                        ]}
                    />
                </div>
                <div className="pagination_footer_pageinfo">
                    <p className="page_details">1-6 of 6</p>
                    <div>
                        <ChevronLeftIcon className={`footer_pagination_icon disabled`} />
                        <ChevronRightIcon className={`footer_pagination_icon`} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MerchantPanel;
